import { render } from "./BadgesPage.vue?vue&type=template&id=2f90cd87"
import script from "./BadgesPage.vue?vue&type=script&lang=js"
export * from "./BadgesPage.vue?vue&type=script&lang=js"
script.render = render

export default script